var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenuCampaign2Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.006 5c.53 0 1.034.2 1.416.566.369.354.59.85.59 1.357v7.666c-.529 0-1.034.2-1.415.566a1.9 1.9 0 00-.591 1.357c0 .507.21.99.59 1.356.37.354.887.567 1.417.567V26.1c0 .507-.21.99-.591 1.356a2.07 2.07 0 01-1.416.566h-24c-.53 0-1.034-.2-1.415-.566A1.9 1.9 0 012 26.101v-7.666c.53 0 1.034-.201 1.415-.567a1.9 1.9 0 00.59-1.356c0-.507-.208-.991-.59-1.357A2.07 2.07 0 002 14.59V6.923c0-.507.21-.991.59-1.357A2.07 2.07 0 014.007 5h24zM10 20.5v3.833h1.994V20.5H10zm0-5.744v3.833h1.994v-3.833H10zM10 9v3.833h1.994V9H10z",
    fill: "#228622"
  })));
}

export default SvgIconMenuCampaign2Filled;